import { render, staticRenderFns } from "./EducationOtherCostsPreview.vue?vue&type=template&id=3be9f022&scoped=true&"
import script from "./EducationOtherCostsPreview.vue?vue&type=script&lang=ts&"
export * from "./EducationOtherCostsPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be9f022",
  null
  
)

export default component.exports